module.exports = __webpack_public_path__ + "img/emmas-logo-white.f73dd090.png";